import type {IframeOpenData} from '@yandex-int/messenger.widget'
import {useCallback, useContext} from 'react'

import {RouteSupportWidgetContext} from './RouteSupportWidgetProvider'

export const useRouteSupportWidgetShow = (params?: IframeOpenData, callback?: (error?: void | Error) => void) => {
  const widget = useContext(RouteSupportWidgetContext)

  return useCallback(() => {
    widget?.show(params, callback)
  }, [widget, params, callback])
}
